<template>
  <div>
    <v-alert
      type="error"
      class="mt-4 mb-2"
      :value="error"
      @input="error = arguments[0] ? error : null"
    >
      {{ error }}
    </v-alert>

    <v-autocomplete
      v-model="realValue"
      :label="label"
      :loading="loading"
      :items="filteredChoices"
      item-value="@id"
      item-text="name"
      return-object
      chips
      small-chips
      :multiple="multiple"
      :search-input.sync="searchValue"
      @change="searchValue = null"
    >
      <template
        slot="selection"
        slot-scope="data"
      >
        <v-chip
          :selected="data.selected"
          class="chip--select-multi"
          close
          @input="removeProject(data.item)"
        >
          {{ data.item.name }}
        </v-chip>
      </template>
      <template
        slot="item"
        slot-scope="data"
      >
        <template v-if="typeof data.item !== 'object'">
          {{ data.item }}
        </template>
        <template v-else>
          {{ data.item.name }}
          <template v-if="data.item.archived">
            <span class="red--text" style="margin-left: 10px; font-weight: bold; font-size: .85em">(Archived)</span>
          </template>
        </template>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { getProjectChoices } from '../helper/getProjectChoices'
import { normalizeToIriObject, removeIriObject } from '../helper/iri'

export default {
  name: 'ProjectPicker',

  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },

  props: {
    modelValue: {
      type: [Array, Object, String],
      default: () => '',
    },

    label: {
      type: String,
      default: 'Client',
    },

    multiple: {
      type: Boolean,
      default: false,
    },

    choiceFilter: {
      type: Function,
      default(item) {
        return item
      },
    },
  },

  data() {
    return {
      loading: false,
      loaded: false,
      error: null,

      choices: [],

      searchValue: null,
    }
  },

  computed: {
    realValue: {
      get() {
        return this.modelValue !== undefined ? normalizeToIriObject(this.modelValue) : null
      },
      set(val) {
        this.$emit('update:modelValue', val)
      },
    },

    filteredChoices() {
      return this.choices.filter(this.choiceFilter)
    },
  },

  methods: {
    load() {
      this.loading = true
      getProjectChoices()
        .then((choices) => {
          this.choices = choices
          this.loaded = true
        })
        .catch(() => {
          this.error = 'Error loading project choices.'
        })
        .then(() => {
          this.loading = false
        })
    },

    removeProject(item) {
      this.realValue = removeIriObject(this.realValue, item)
    },
  },

  created() {
    this.load()
  },
}
</script>
